import { AspectRatio, Stack, Text } from '@chakra-ui/react';
import { EmbedVideo } from '@time-line/components/common';

export interface VideoProps {
  url: string;
  title?: string;
}

export function Video({ url, title }: VideoProps) {
  return (
    <Stack className="media" spacing="4xs">
      <AspectRatio ratio={16 / 9}>
        <EmbedVideo title={title} url={url} controls />
      </AspectRatio>

      {title && (
        <Text color="blackAlpha.700" size="detail">
          {title}
        </Text>
      )}
    </Stack>
  );
}
